export const EUR_TO_BGN_RATE = 1.95583;
export const CURRENCY_SWITCH_DATE_LOCAL = new Date(2026, 0, 1);

export const toNumberOrNull = (value) => {
  if (value === null || value === undefined) return null;
  if (value === "-" || value === "") return null;
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
};

export const round2 = (value) => {
  const num = toNumberOrNull(value);
  if (num === null) return null;
  return Math.round((num + Number.EPSILON) * 100) / 100;
};

export const convertCurrency = (amount, fromCurrency, toCurrency) => {
  const value = toNumberOrNull(amount);
  if (value === null) return null;
  if (fromCurrency === toCurrency) return round2(value);

  if (fromCurrency === "EUR" && toCurrency === "BGN") {
    return round2(value * EUR_TO_BGN_RATE);
  }
  if (fromCurrency === "BGN" && toCurrency === "EUR") {
    return round2(value / EUR_TO_BGN_RATE);
  }

  return round2(value);
};

export const getCurrencySymbol = (currency) => {
  if (currency === "EUR") return "€";
  if (currency === "BGN") return "лв.";
  return currency || "";
};

export const formatMoney = (amount) => {
  const num = toNumberOrNull(amount);
  if (num === null) return "---";
  return Number(num).toFixed(2);
};

export const formatCurrencyAmount = (amount, currency) =>
  `${formatMoney(amount)} ${getCurrencySymbol(currency)}`;

export const getOfferDualAmounts = (offer, key) => {
  const eur = toNumberOrNull(offer?.[key]);
  const bgn = toNumberOrNull(offer?.bgn?.[key]);

  return {
    EUR: eur ?? convertCurrency(bgn, "BGN", "EUR"),
    BGN: bgn ?? convertCurrency(eur, "EUR", "BGN"),
  };
};

export const inferOfferBaseCurrency = (offer, referenceDate = new Date()) => {
  if (offer?.bgn) return "EUR";

  return getBaseCurrencyBySwitchDate(referenceDate);
};

export const getOfferDualAmountsWithBase = (offer, key, baseCurrency) => {
  const base = toNumberOrNull(offer?.[key]);
  if (base === null) return { EUR: null, BGN: null };

  if (baseCurrency === "BGN") {
    return {
      BGN: base,
      EUR: convertCurrency(base, "BGN", "EUR"),
    };
  }

  return {
    EUR: base,
    BGN: convertCurrency(base, "EUR", "BGN"),
  };
};

export const formatDualCurrency = (amounts, order = ["EUR", "BGN"]) => {
  const [primary, secondary] = order;
  const primaryAmount = amounts?.[primary];
  const secondaryAmount = amounts?.[secondary];

  const primaryNum = toNumberOrNull(primaryAmount);
  const secondaryNum = toNumberOrNull(secondaryAmount);

  if (primaryNum === null && secondaryNum === null) return "---";

  const primaryText = formatCurrencyAmount(primaryAmount, primary);
  const secondaryText =
    secondaryNum === null ? null : formatCurrencyAmount(secondaryAmount, secondary);

  return secondaryText ? `${primaryText} (${secondaryText})` : primaryText;
};

export const getDisplayCurrencyOrderBySwitchDate = (now = new Date()) =>
  now >=  CURRENCY_SWITCH_DATE_LOCAL ? ["EUR", "BGN"] : ["BGN", "EUR"];

export const getBaseCurrencyBySwitchDate = (now = new Date()) =>
  now >= CURRENCY_SWITCH_DATE_LOCAL ? "EUR" : "BGN";

export const getDualAmountsFromBase = (amount, baseCurrency) => {
  const base = toNumberOrNull(amount);
  if (base === null) return { EUR: null, BGN: null };
  const baseCur = baseCurrency === "EUR" ? "EUR" : "BGN";
  return {
    EUR: baseCur === "EUR" ? base : convertCurrency(base, "BGN", "EUR"),
    BGN: baseCur === "BGN" ? base : convertCurrency(base, "EUR", "BGN"),
  };
};


